require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-mystic-impact-cap.json") })
        }
      }, "path---reviews-mystic-impact-cap");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-mystic-impact-cap!./.cache/json/reviews-mystic-impact-cap.json
// module id = 688
// module chunks = 231608221292675